import {useQueryParamValue} from '@hconnect/common/hooks'
import {useCallback} from 'react'
import {useParams, useLocation, useNavigate} from 'react-router'

import {DEFAULT_TIME_RANGE, KEY_TIME_RANGE, RouteSegment} from '../consts'

export const useStoppageAnalysisPageParams = () => {
  const [timeRangeParam, setTimeRangeParam] = useTimeRangeParam()
  const {equipmentId, replaceEquipmentIdParam} = useEquipmentIdParam()

  return {
    timeRangeParam,
    setTimeRangeParam,
    equipmentId,
    replaceEquipmentIdParam
  }
}

const useTimeRangeParam = (): [string, (value: string) => void] => {
  const [timeRange, setTimeRange] = useQueryParamValue<string>(KEY_TIME_RANGE, {
    keepInLocalStorage: true
  })
  return [timeRange || DEFAULT_TIME_RANGE, setTimeRange]
}

type PathParams = {
  equipmentId?: string
}

export const useEquipmentIdParam = () => {
  const {equipmentId} = useParams<PathParams>()

  const location = useLocation()
  const navigate = useNavigate()

  const replaceEquipmentIdParam = useCallback(
    (newEquipmentId: string) => {
      if (!equipmentId) {
        throw new Error('equipmentId is missing in the URL parameters')
      }

      const newPath = location.pathname.replace(
        `/${RouteSegment.EQUIPMENT}/${equipmentId}`,
        `/${RouteSegment.EQUIPMENT}/${newEquipmentId}`
      )
      // Persist query params
      void navigate(`${newPath}${location.search}`)
    },
    [equipmentId, location, navigate]
  )

  return {
    equipmentId,
    replaceEquipmentIdParam
  }
}
